import React from 'react';
import {
  GoodDetailMinPrice, FullDiscountExtraInfo, SelectedGroupSkuList, DiscountPriceItem
} from '../../../pages/shop/c_shop/component';

export class SelectedSku {
  skuId: number;
  groupList?: {
    groupId: number;
    groupSkuList: SelectedGroupSkuList[];
  }[];
  fullDiscountExtraInfo: FullDiscountExtraInfo = {
    isMeetSillAmount: 0,
    fullDiscountTips: '',
    fullDiscountToast: '',
    fullDiscountTipsIconFront: '',
    fullDiscountTipsIconLast: '',
    sillAmount: {
      amount: 0,
      currency: '',
      displayAmount: '',
      displayText: ''
    }
  };
  discountPriceList: DiscountPriceItem[] = [];

  constructor(skuId: number,) {
    this.skuId = skuId;
  }
}

export class TotalPrice {
  originPrice = {} as GoodDetailMinPrice;
  discountPrice = {} as GoodDetailMinPrice;
  currency: string = '';
}

export class RequairedSkuGroup {
  skuId: number;
  groupList: RequairedSkuGroupList[] | [];
  constructor(skuId: number, groupList: RequairedSkuGroupList[] | []) {
    this.skuId = skuId,
    this.groupList = groupList;
  }
}

class RequairedSkuGroupList {
  groupId: number = 0;
  minCount: number = 0;
  ref: any = React.createRef();
}

export interface MultiSkuSource {
  sourceNum: number;
  orderRequestSource: number;
}
